export default __webpack_public_path__ + "static/media/cv_round.a32ca70b.jpg";